// Reusable Checkbox Component
import React, { useState } from 'react';
import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { LocationOption } from '../../types/global/helper';

interface CheckboxGroupProps {
    options: LocationOption[]; // Array of location options
    onChange: (value: LocationOption | null) => void; // Callback to handle change, returns selected option or null
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ options, onChange }) => {
    const [selectedOption, setSelectedOption] = useState<LocationOption | null>(null);
    const { themeStyle } = useThemeContext();

    const handleChange = (option: LocationOption) => {
        const isSelected = selectedOption?.label === option.label;
        const newSelectedOption = isSelected ? null : option;

        setSelectedOption(newSelectedOption);
        onChange(newSelectedOption); // Notify parent about the change
    };

    return (
        <FormGroup row>
            {options.map(option => (
                <FormControlLabel
                    key={option.label}
                    control={
                        <Checkbox
                            checked={selectedOption?.label === option.label}
                            onChange={() => handleChange(option)}
                            sx={{
                                color: theme[themeStyle].gray_sidebar,
                                '&.Mui-checked': {
                                    color: theme[themeStyle].highlight,
                                },
                                '&.MuiCheckbox-indeterminate': {
                                    color: theme[themeStyle].highlight,
                                },
                            }}
                        />
                    }
                    label={
                        <Typography
                            style={{
                                fontSize: '12px',
                                color: theme[themeStyle].tag_white,
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                textTransform: 'capitalize',
                            }}>
                            {option.label}
                        </Typography>
                    }
                />
            ))}
        </FormGroup>
    );
};

export default CheckboxGroup;
